import React from 'react';
import T from 'prop-types';
// hoc
import withSizes from 'react-sizes';
// utils
import isEmpty from 'lodash.isempty';
// styles
import styles from './ValuesChart.mod.css';
import classnames from 'classnames/bind';
import RecoverySection from './RecoverySection';

let cx = classnames.bind(styles);

export const shouldChartRender = data => {
  if (isEmpty(data)) return false;
  return !['away', 'consistency', 'importance', 'towards'].every(
    key => data[0][key] === null
  );
};

const ValuesChart = ({ isMobile, isDesktop, valueChart, placeholder }) => {
  const colors = ['#33C370', '#8a3ec1', '#d63ec4', '#56CCF2', '#ffc132'];

  if (isDesktop) {
    return (
      <RecoverySection title="Values chart" placeholder={`${placeholder} 5`}>
        {shouldChartRender(valueChart) && (
          <div className={cx('wrapper')}>
            <div className={cx('container')}>
              <div className={cx('row')}>
                {valueChart.map(({ id, title }, index) => (
                  <div
                    className={cx('cell')}
                    key={id}
                    style={{ color: colors[index] }}
                  >
                    <span className={cx('title-cell')}>{title}</span>

                    {['consistency', 'importance'].map(key => {
                      const value = valueChart[index][key];
                      return (
                        <div
                          key={key}
                          className={cx('criterion', {
                            hidden: value === null
                          })}
                        >
                          <span className={cx('criterion-title')}>{key}: </span>
                          <span className={cx('criterion-value')}>{value}</span>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
              {['towards', 'away'].map(key => (
                <div key={key} className={cx('row')}>
                  {valueChart.map(({ id, title }, index) => {
                    const value = valueChart[index][key];
                    return (
                      <div
                        key={id}
                        className={cx('value-cell', {
                          hidden: value === null
                        })}
                      >
                        <p className={cx('progress-title')}>{key}</p>
                        <p className={cx('value')}>{value}</p>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        )}
      </RecoverySection>
    );
  }
  if (isMobile) {
    return (
      <RecoverySection title="Values chart" placeholder={`${placeholder} 5`}>
        {shouldChartRender(valueChart) && (
          <div className={cx('mob-container')}>
            {valueChart.map(({ consistency, id, importance, title }, index) => {
              const color = colors[index];
              return (
                <div key={id} className={cx('column')}>
                  <div className={cx('cell')} key={id} style={{ color }}>
                    <span className={cx('title-cell')}>{title}</span>
                  </div>
                  {['consistency', 'importance'].map(key => {
                    const value = valueChart[index][key];
                    return (
                      <div
                        key={key}
                        className={cx('criterion', {
                          hidden: value === null
                        })}
                      >
                        <span className={cx('criterion-title')}>{key}: </span>
                        <span
                          className={cx('criterion-value')}
                          style={{ color }}
                        >
                          {value}
                        </span>
                      </div>
                    );
                  })}

                  {['towards', 'away'].map(key => {
                    const value = valueChart[index][key];
                    return (
                      <div
                        className={cx('column', { hidden: value === null })}
                        key={key}
                      >
                        <p className={cx('progress-title')}>{key}</p>
                        <p className={cx('value')}>{value}</p>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        )}
      </RecoverySection>
    );
  }
};

ValuesChart.propTypes = {
  isMobile: T.bool,
  isDesktop: T.bool,
  data: T.arrayOf(T.object)
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
  isDesktop: width >= 768
});

export default withSizes(mapSizesToProps)(ValuesChart);



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/ValuesChart.jsx